<template>
    <v-container fluid class="pa-0 d-flex" style="height: 100vh;">

        <div class="responsive-div rounded-0 ma-0 pa-16">
            <img @click="reload()" alt="logo_fisi" src="../assets/fisi.jpg" width="100" />
            <div class="ma-10">
                <v-card-title class="text-h3 font-weight-bold pl-0 text-blue" v-if="!estMobile">Connexion</v-card-title>

                <v-card-subtitle class="text-h4 pl-0 line-break mb-6 text-blue" style="line-height: 1.1;" v-if="!estMobile">
                    Connectez vous à votre espace Fisi en un clic.
                </v-card-subtitle>

                <v-form v-model="valid" @submit.prevent="connecter">
                    <div class="text-subtitle-1 text-medium-emphasis">Identifiant</div>

                    <v-text-field density="compact"
                                  placeholder="Entrez votre identifiant"
                                  variant="outlined"
                                  name="identifiant"
                                  autocomplete="username"
                                  v-model="id"
                                  @keyup.enter="connecter"></v-text-field>

                    <div class="text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between">
                        Mot de passe

                        <a class="text-caption text-decoration-none text-blue"
                           @click="forgotPassword()">
                            Mot de passe oublié ?
                        </a>
                    </div>

                    <v-text-field :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
                                  :type="visible ? 'text' : 'password'"
                                  density="compact"
                                  placeholder="Entrez votre mot de passe"
                                  variant="outlined"
                                  name="motdepasse"
                                  autocomplete="current-password"
                                  v-model="mdp"
                                  @click:append-inner="visible = !visible"
                                  @keyup.enter="connecter"></v-text-field>

                    <div v-if="errorConnexion && !isLoading" style="text-align:center" class="mb-6">
                        <span style="font-size: 16px; text-align: center; color: #FF4A6B;">{{ errorMessage}}</span>
                    </div>

                    <div v-else-if="isLoading" style="display:flex;align-items:center;justify-content:center;">
                        <Loader />
                    </div>
                    <v-btn class="mb-4"
                           color="#032272"
                           size="large"
                           elevation="8"
                           block
                           type="submit">
                        Se connecter
                    </v-btn>
                </v-form>

                <p class="mt-4 text-center">
                    Pas encore de compte ?
                    <router-link class="font-weight-bold text-blue" style="display:inline;" :to="{ name : 'Inscription' }" tag="a">
                        Inscrivez vous !
                    </router-link>
                </p>

                <v-divider class="mx-4 mb-8" thickness="4"></v-divider>

                <div class="text-center pa-4">
                    <v-dialog v-model="dialog"
                              max-width="400">
                        <template v-slot:activator="{ props: activatorProps }">
                            <p v-bind="activatorProps"
                               class="text-caption text-decoration-none text-blue font-weight-bold cursor-pointer"
                               style="text-align: center; display: block; font-size: 15px !important">
                                Se connecter avec la carte CPS
                                <img alt="logo_prosanteconnect" src="../assets/cartescps.jpg" width="250px" class="mt-3" />
                            </p>
                        </template>

                        <v-card class="px-10 py-8"
                                elevation="16"
                                max-width="344">

                            <v-card-title class="pl-0 mb-8 text-blue" style="display: flex; flex-direction: column; line-height: 1; gap: 0; font-size: 26px;">
                                <span class="font-weight-bold" style="margin-bottom: 0; padding: 0;">Se connecter</span>
                                <span style="margin-top: 4px; padding: 0;">avec la carte CPS</span>
                            </v-card-title>



                            <div class="text-subtitle-1 text-medium-emphasis text-center">Code CPS</div>

                            <v-text-field density="compact"
                                          placeholder="Entrez votre code CPS"
                                          variant="outlined"
                                          v-model="codeCPS"
                                          @keyup.enter="validerCodeCPS"></v-text-field>

                            <p v-if="! getNbTentativeMaximumCodeCPSAtteint" style="text-align: center;">Nombre de tentatives restantes : {{getNbTentativeDuCodeCPS}}</p>
                            <p v-else style="text-align: center;">{{getMessageNombreMaximumTentativeCodeCPSAtteint}}</p>
                            
                            <br />
                            <p v-if="getErreurCodeCPS" class="text-danger"> Code CPS incorrect</p>

                            <p v-if="connexionErrorMessageAvecCarteCPS"
                               style="text-align:center; color:#FF4A6B; font-size:15px;" class="mt-2">
                                {{ connexionErrorMessageAvecCarteCPS }}
                            </p>

                            <p v-if="connexionErrorNumberAvecCarteCPS ==0 " class="mt-4 text-center">
                                Vous n'avez pas encore de compte !
                                <router-link class="font-weight-bold text-blue" style="display:inline;" :to="{ name : 'Inscription' }" tag="a">
                                    Inscrivez vous !
                                </router-link>
                            </p>
                            <p v-if="connexionErrorNumberAvecCarteCPS == 2" class="mt-4 text-center">
                                {{ connexionErrorMessageAvecCarteCPSLireVitale }}
                            </p>
                            <div v-if="isLoadingFormCPS">
                                <Loader v-if="isLoading" />
                            </div>
                            <v-btn class="mb-4"
                                   color="#032272"
                                   size="large"
                                   elevation="8"
                                   block
                                   type="submit"
                                   @click="validerCodeCPS">
                                Se connecter
                            </v-btn>

                            <v-btn class="mb-4"
                                   color="#395293"
                                   size="large"
                                   elevation="8"
                                   block
                                   type="submit"
                                   @click="dialog = false">
                                Annuler
                            </v-btn>
                        </v-card>
                    </v-dialog>
                </div>
            </div>
            <p class="text-blue-grey-lighten-1">© 2025 Francilienne d’ingénierie et de Services Informatiques</p>
        </div>
        <div class="background w-100 d-flex flex-column pa-16"  v-if="!estMobile">
            <div class="mt-auto mb-200 text-white" style="z-index: 1;">
                <h1 style="font-size: 70px; line-height: 1.1;" class="mb-5">
                    Des logiciels au
                    <br />
                    service des médecins
                </h1>
                <h2 style="font-size: 40px; line-height: 1.3; ">
                    Notre offre vous permet de gérer
                    <br />
                    en toute simplicité votre cabinet
                    <br />
                    médical tout au long de l'année.
                </h2>
            </div>
        </div>

    </v-container>

</template>

<script>
    import { defineComponent } from 'vue';
    import Loader from './Loader.vue';
    import Connexion from '../script/Connexion.js';
    import { appliDuDomaine } from '../script/appli.js';
    import RequestManager from '../script/request';
    import { mapActions } from 'vuex';
    import { mapGetters } from 'vuex';


    export default defineComponent({
        components: {
            Loader
        },

        data: function () {
            return {
                codeCPS: '',
                nonceCPS: null,
                id: '',
                mdp: '',
                connecte: localStorage.connecte,
                errorConnexion: false,
                errorMessage: "Identifiant ou mot de passe incorrect !",
                connexionErrorMessageAvecCarteCPS: null,
                connexionErrorNumberAvecCarteCPS : null,
                isLoading: false,
                isLoadingFormCPS : false,
                dialog: false,
                email: '',
                password: '',
                valid: false,
                visible: false,
            }
        },

        computed: {
            estMobile() {
                return RequestManager.estMobile;
            },
            nom() {
            },
            getCarteCPS() {
                return this.$store.getters['Cartes/getCarteCPS']
            },
            getErreurCodeCPS() {
                return this.$store.getters['Cartes/getErreurCodeCPS'];
            },
            getNbTentativeDuCodeCPS() {
                return this.$store.getters['Cartes/getNbTentativeDuCodeCPS'];
            },
            getConnexionReussieAvecCarteCPS() {
                return this.$store.getters["Cartes/getConnexionReussieAvecCarteCPS"];
            },
            getChallengeSigne() {
                return this.$store.getters["Cartes/getChallengeSigne"];
            },
            identifiantsMobile() {
                return this.$store.getters["ConnexionStore/getIdentifiantsMobile"];
            },
                ...mapGetters('Cartes', [
                    'getMessageNombreMaximumTentativeCodeCPSAtteint',
                    'getNbTentativeMaximumCodeCPSAtteint'
                ]
                )
            
        },
        
        methods: {
            estLoginFisi(id) {
                return typeof id === 'string' && id.trim().toUpperCase() === 'FISI';
            },
            enregistrerRedirectionLoginFisi(estLoginFisi) {
                if (estLoginFisi) {
                    localStorage.setItem('redirigerVersChoixApplicationQuandDejaConnecte', 'true');
                    localStorage.removeItem('appliLance');
                    localStorage.setItem('appliLaunched', 'false');
                    this.$store.dispatch("ConnexionStore/setAppliLaunched", false);
                    return;
                }

                localStorage.removeItem('redirigerVersChoixApplicationQuandDejaConnecte');
            },
            connexionAvecCPS(CPS) {
                let utilisateur = {
                    nom: CPS[0].Fields[5],
                    prenom: CPS[0].Fields[6],
                    // Format PSC classique = type identifiant (Fields[1], "8" pour RPPS)
                    // concatene au RPPS lui-meme (Fields[2]) -> ex : "8" + "99700723077" = "899700723077"
                    RPPS: `${CPS[0].Fields[1]}${CPS[0].Fields[2]}`,
                    adresse1: "",
                    email: "",
                    mdp: "",
                    tel: "",
                    confirmMdp: "",
                    lesCabinets: []
                };
                //alert("On se connecte");
                Connexion.connecterWithRPPS(utilisateur.RPPS)
                    .then(response => {
                        //this.errorConnexion = !response.success
                        //this.$store.dispatch("ConnexionStore/setConnexion", response);
                        this.$store.commit("Cartes/setConnexionReussieAvecCarteCPS", response.success)
                        console.log("connecterWithRPPS, response =", response )
                        if (response.success) {
                            this.dialog = false
                            this.$store.dispatch("ConnexionStore/setConnexion", response);
                            if (this.rediriger(response)) return;
                            this.$router.push({ name: "TransCAM" })
                        }
                        else {
                            this.connexionErrorMessageAvecCarteCPS = response.resMsg
                            this.connexionErrorNumberAvecCarteCPS = response.resNum
                        }
                });
            },
            
            connecter() {
                this.isLoading = true;
                Connexion.connecter(this.id, this.mdp).then(response => {
                    this.isLoading = false;

                    // Echec d'authentification (identifiants invalides / compte introuvable)
                    if (!response || response.success !== true) {
                        this.errorConnexion = true;
                        this.errorMessage = (response && response.resMsg)
                            ? response.resMsg
                            : "Identifiant ou mot de passe incorrect !";
                        return;
                    }

                    // Authentifie : on enregistre l'etat (token + lien backend eventuel)
                    this.enregistrerRedirectionLoginFisi(this.estLoginFisi(this.id));
                    this.$store.dispatch("ConnexionStore/setConnexion", response);

                    // Enregistrement securise des identifiants cote natif (SecureStorage) en WebView mobile.
                    // Sans effet hors WebView (EnvoyerMessageWebView ne fait rien si !avecWebView).
                    RequestManager.EnvoyerMessageWebView({ action: "sauvegarderIdentifiants", parameters: [this.id, this.mdp] });

                    // BackEndLink vide => le compte n'a pas d'instance backend en ligne.
                    // L'utilisateur est connecte mais reste en mode local : on l'informe.
                    const aBackend = response.BackEndLink && response.BackEndLink.trim() !== "";
                    if (!aBackend) {
                        this.errorConnexion = true;
                        this.errorMessage = "Connexion réussie, mais pas de backend disponible pour ce compte.";
                        return;
                    }

                    this.errorConnexion = false;

                    // Application imposee par le domaine d'entree et servie par une
                    // interface qui lui est propre (AG2035) : le portail s'arrete ici. On
                    // quitte pour l'instance du praticien, en lui passant le ticket a usage
                    // unique — jamais le jeton, qui vit quatre heures et finirait dans les
                    // journaux nginx, l'historique et le Referer.
                    if (this.rediriger(response)) return;

                    // Backend en ligne disponible : on entre dans l'application
                    this.$router.push({
                        name: this.estLoginFisi(this.id) ? "ChoixAppli" : "TransCAM"
                    });
                });
            },

            // Renvoie true si le praticien a ete envoye sur son instance (la page est alors
            // en train de changer d'adresse, l'appelant doit s'arreter la).
            rediriger(response) {
                const appli = appliDuDomaine();
                if (!appli || !appli.redirigeVersInstance) return false;

                const ticket = response && response.Ticket;
                const lien = response && response.BackEndLink && response.BackEndLink.trim();
                if (!ticket || !lien) return false;

                const base = lien.replace(/\/+$/, "");
                window.location.assign(
                    base + appli.cheminEntree + "?ticket=" + encodeURIComponent(ticket));
                return true;
            },


            async validerCodeCPS() {
                this.isLoadingFormCPS = true;
                this.connexionErrorMessageAvecCarteCPS = null;
                // Auth CPS forte : on demande un challenge au serveur, puis on fait signer
                // ce nonce par la carte cote natif (qui lit la CPS avec le code PIN et
                // renvoie l'assertion SAML signee via l'action ChallengeCPSSigne).
                try {
                    console.log("[CPS] 1/4 demande de challenge au backend...");
                    const challenge = await Connexion.getChallengeCPS();
                    if (!challenge || challenge._erreur || !challenge.nonce) {
                        this.isLoadingFormCPS = false;
                        this.connexionErrorMessageAvecCarteCPS =
                            (challenge && challenge._erreur) ? challenge._erreur
                            : "Impossible d'obtenir un challenge du serveur (réponse vide).";
                        console.error("[CPS] echec challenge :", this.connexionErrorMessageAvecCarteCPS);
                        return;
                    }
                    this.nonceCPS = challenge.nonce;
                    console.log("[CPS] 2/4 challenge OK, envoi au natif pour signature carte.");
                    RequestManager.EnvoyerMessageWebView({ action: "SignerChallengeCPS", parameters: [this.codeCPS, challenge.nonce] });
                } catch (e) {
                    this.isLoadingFormCPS = false;
                    this.connexionErrorMessageAvecCarteCPS = "Erreur lors de l'obtention du challenge CPS.";
                    console.error("[CPS] validerCodeCPS / challenge :", e);
                }
            },

            // Recoit l'assertion SAML signee par la carte (relayee par App.vue via le store),
            // la poste au backend et traite la connexion comme un login classique.
            connecterAvecChallengeSigne(assertionSignee) {
                if (!this.nonceCPS) {
                    this.isLoadingFormCPS = false;
                    this.connexionErrorMessageAvecCarteCPS = "Challenge CPS absent (relancez la connexion).";
                    console.error("[CPS] connecterAvecChallengeSigne sans nonce courant");
                    return;
                }
                console.log("[CPS] 4/4 envoi de l'assertion signée au backend...");
                Connexion.connecterWithCPS(this.nonceCPS, assertionSignee)
                    .then(response => {
                        this.isLoadingFormCPS = false;
                        // Le nonce est a usage unique : on l'oublie quoi qu'il arrive.
                        this.nonceCPS = null;
                        this.$store.commit("Cartes/setConnexionReussieAvecCarteCPS", response && response.success);
                        if (response && response.success) {
                            console.log("[CPS] connexion réussie.");
                            // Carte deverrouillee par le PIN de login (statut cryptoki ACTIVE) :
                            // la lecture complete part avec un PIN vide, le PIN n'est jamais conserve.
                            // Lecture complete de la carte (deja deverrouillee) avec un PIN
                            // vide pour charger praticien + situations sans redemander le PIN.
                            RequestManager.EnvoyerMessageWebView({ action: "LireCartePS", parameters: ["", "apresConnexion"] });
                            // On ne garde pas le PIN en memoire du composant.
                            this.codeCPS = '';
                            this.dialog = false;
                            this.$router.push({ name: "TransCAM" });
                            this.$store.dispatch("ConnexionStore/setConnexion", response);
                        }
                        else {
                            // _erreur = probleme reseau (backend injoignable / HTTP) ;
                            // resMsg = refus d'authentification renvoye par le backend (raison precise).
                            this.connexionErrorMessageAvecCarteCPS =
                                (response && response._erreur) ? response._erreur
                                : (response && response.resMsg) ? response.resMsg
                                : "Connexion CPS échouée (cause inconnue).";
                            this.connexionErrorNumberAvecCarteCPS = response ? response.resNum : null;
                            console.error("[CPS] échec backend :", this.connexionErrorMessageAvecCarteCPS, response);
                        }
                    });
            },

            forgotPassword() {
                // Ce lien existait depuis longtemps et ne faisait qu'un console.log : il n'y
                // avait aucune reinitialisation, ni ici ni cote backend.
                this.$router.push({ name: 'MotDePasseOublie' });
            },
            // Preremplit les champs login depuis les identifiants natifs (SecureStorage), sans ecraser une saisie en cours
            prefillIdentifiants(creds) {
                if (!creds) return;
                if (creds.id && !this.id) this.id = creds.id;
                if (creds.mdp && !this.mdp) this.mdp = creds.mdp;
            }
        },

        watch: {
            getCarteCPS(newCartePS) {
                //alert("Début dans Accueil.vue watch : getCartePS")
                if (newCartePS != "" && newCartePS != null && newCartePS != 'Error') {
                    //alert("Dans Accueil.vue watch : getCartePS\nnewCartePS != \"\" && newCartePS != null && newCartePS != 'Error'");
                    this.connexionAvecCPS(newCartePS);
                    /*this.dialog = false;*/
                    this.cpsChargéAvecSuccé = true;
                }
                else {
                    //alert("dans Accueil.vue watch : getCartePS ligne 282 dans le else")
                    this.$store.commit('Cartes/decrementerNbTentativeDuCodeCPS')
                    //alert("newCarteCPS null ou vide")
                }
            },
            getConnexionReussieAvecCarteCPS(newValue) {
                if (newValue == false)
                    console.log("Erreur de connexion !! ");
                else
                    console.log("Connexion réussie !!")
            },
            // Assertion CPS signee renvoyee par le natif (relais store) -> POST backend.
            getChallengeSigne(newVal) {
                if (newVal == null) return;
                console.log("[CPS] 3/4 assertion reçue du natif.");
                // Le natif peut renvoyer un tableau [assertion] ou directement la chaine.
                const assertion = Array.isArray(newVal) ? newVal[0] : newVal;
                // Reset immediat pour ne pas re-declencher sur une valeur perimee.
                this.$store.commit('Cartes/setChallengeSigne', null);
                if (!assertion || assertion === "" || assertion === "Error") {
                    this.isLoadingFormCPS = false;
                    this.nonceCPS = null;
                    this.$store.commit('Cartes/decrementerNbTentativeDuCodeCPS');
                    this.connexionErrorMessageAvecCarteCPS = "Échec de lecture ou de signature de la carte CPS (côté lecteur).";
                    console.error("[CPS] le natif a renvoyé une erreur de signature :", assertion);
                    return;
                }
                this.connecterAvecChallengeSigne(assertion);
            },
            // Identifiants renvoyes par le natif (SecureStorage) -> preremplir le login
            identifiantsMobile(creds) {
                this.prefillIdentifiants(creds);
            }
        },
        mounted() {
            // Si les identifiants natifs sont deja arrives (course async), preremplir immediatement.
            this.prefillIdentifiants(this.identifiantsMobile);
        }
    });
</script>

<style scoped>
    .background {
        background-image: url('../assets/image-05.jpg');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        min-height: 100vh;
        position: relative;
    }

        .background::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(3, 34, 114, 0.3);
        }

    .v-card {
        box-shadow: 0 2px 10px grey;
    }

    .mb-200 {
        margin-bottom: 200px;
    }

    .line-break {
        white-space: normal;
    }

    .text-blue {
        color: #032272 !important;
    }

    .responsive-div {
        width: 100%;
        height: 100%;
    }

    @media (min-width: 1300px) {
        .responsive-div {
            width: 1000px;
            height: 100%;
        }
    }
</style>
